import { useEffect, useState } from 'react';
import './QuoteDocumentRow.css'
import { FaFilePdf, FaFileCsv, FaFileAlt, FaFileImage } from 'react-icons/fa';
import { getDocument, downloadDocument } from '../data/fileData';
import { updateDocumentVisibility } from '../data/jobData';
import { Switch } from '@progress/kendo-react-inputs';
const apiURL = process.env.REACT_APP_API_URL;

const QuoteDocumentRow = (props: any) => {
   const [fileIcon, setFileIcon] = useState(<FaFilePdf />);
   const [lastUpload, setLastUpload] = useState(props.onLastUpload);
   const [isVisible, setIsVisible] = useState(props.appCanView || false);
   const [isUpdating, setIsUpdating] = useState(false);
   const quoteId = props.onQuoteId;
   const jobId = props.onJobId;

   useEffect(() => {
   }, [lastUpload]);

   useEffect(() => {
      console.log('QuoteDocumentRow - appCanView prop changed:', props.appCanView, 'for file:', props.onFileName);
      setIsVisible(props.appCanView || false);
   }, [props.appCanView]);

   useEffect(() => {
      console.log('QuoteDocumentRow - isVisible state:', isVisible, 'for file:', props.onFileName);
   }, [isVisible]);

   const icon = (fileType: string) => {
      switch (fileType) {
         case '.pdf':
            return <FaFilePdf style={{ fontSize: "20pt", color: "#1e2a4e", marginRight: "1rem" }} />
         case '.csv':
            return <FaFileCsv style={{ fontSize: "20pt", color: "#1e2a4e", marginRight: "1rem" }} />
         case '.txt':
            return <FaFileAlt style={{ fontSize: "20pt", color: "#1e2a4e", marginRight: "1rem" }} />
         case '.jpg':
            return <FaFileImage style={{ fontSize: "20pt", color: "#1e2a4e", marginRight: "1rem" }} />
         case '.png':
            return <FaFileImage style={{ fontSize: "20pt", color: "#1e2a4e", marginRight: "1rem" }} />
         default:
            return <FaFileAlt style={{ fontSize: "20pt", color: "#1e2a4e", marginRight: "1rem" }} />
      }
   }



   const viewHandler = async () => {
      await getDocument(props.onDocumentId, props.onFileName);
   }

   const downloadHandler = async () => {
      await downloadDocument(props.onDocumentId, props.onFileName);
   }

   const handleDocumentDelete = () => {
      props.onDocumentDelete(props.onDocumentId);
   }

   const handleVisibilityToggle = async () => {
      if (isUpdating) return;
      
      setIsUpdating(true);
      try {
         await updateDocumentVisibility(jobId, quoteId, props.onDocumentId, !isVisible);
         setIsVisible(!isVisible);
      } catch (error) {
         console.error('Failed to update document visibility:', error);
         // You could add a toast notification here to inform the user of the error
      } finally {
         setIsUpdating(false);
      }
   }



   useEffect(() => {
      const fetchDocumentIcon = async () => {
         const fileIcon = icon(props.onFileExtension);
         setFileIcon(fileIcon);
      };

      fetchDocumentIcon();
   }, [quoteId]);

   return (
      <div className="quotedoc__row__container">
         <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
            <div>
               {fileIcon}
            </div>
            <div style={{ fontSize: "10pt", display: "flex", alignItems: "center" }}>
               <p style={{ margin: 0, fontWeight: "400" }}>{props.onFileName}</p>
               {props.isSurveyFile && (
                  <span style={{ marginLeft: "0.5rem", padding: "1px 6px", borderRadius: "4px", fontSize: "8pt", fontWeight: 600, background: "#d8e5ed", color: "#1e2a4e" }}>Survey</span>
               )}
            </div>
         </div>
         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {props.showVisibilityToggle !== false && !props.readOnly && (
               <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "8pt" }}>
                  <label style={{ marginBottom: "2px", color: "#666", fontWeight: "400" }}>View in mobile app</label>
                  <Switch
                     checked={isVisible}
                     onChange={handleVisibilityToggle}
                     disabled={isUpdating}
                  />
               </div>
            )}
            <div>
               <button style={{ marginRight: "5px" }} onClick={viewHandler} className='quotedoc__row__button'>view</button>
               <button style={{ marginRight: "5px" }} onClick={downloadHandler} className='quotedoc__row__button'>download</button>
               {props.canDelete !== false && !props.readOnly && (
                  <button onClick={handleDocumentDelete} className='quotedoc__row__deletebutton'>delete</button>
               )}
            </div>
         </div>
      </div>

   );
}

export default QuoteDocumentRow;